import React, { Component, useContext } from "react";
import { Splitter } from "@progress/kendo-react-layout";
import { Navigate, useNavigate } from "react-router-dom";
import EntityPropertyPanel from "./EntityPropertyPanel";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import CreateEntityDialog from "./CreateEntityDialog";
import { PageContainer, Header, Content } from "../Drawer/PageContainer";
import RemoveDialog from "../Shared/Remove/RemoveDialog";
import SaveDialog from "../Shared/Remove/SaveDialog";
import Loader from "../Shared/Loader/loader";
import { updateNode } from "../Helpers/Nodes";
import { CheckForInternalUser } from '../Helpers/miscellaneous'
import { MsalContext } from "@azure/msal-react";
import Scrollable from "../Shared/Edit/Scrollable";
import Upgarde from "../Shared/Subscription/Upgrade";
import ServerError from "../Shared/Error/ServerError";
import { ENTITY_LABEL } from "../Helpers/Labels/EntityLabel";
import WorkspaceAppModelContext from "../../Context/Workspace/WorkspaceAppModelContext";
import AliceRecommendedEntitiesDialog from "./Recommendation/AliceRecommendedEntitiesDialog";
import { Checkbox } from "@progress/kendo-react-inputs";
import { getAllAttributes } from "../Helpers/Schema/Schema";
import { withTranslation } from 'react-i18next';
import { bulkDeleteEnities, deleteEntity, getEntities, updateEntity } from "../../API/Entity/Entity";
import { findEntityAttributeReferencesInFormulas, updateAttribute } from "../../API/Attribute/Attribute";
import AIChatBox from "../AIAgent/Chatbox";
import RealtimeAPIChatbox from "../AIAgent/RealtimeAPIChatbox";
import { propogateChangeToRealtimeIframe } from "../Helpers/Runtime/runtime";

class DragCell extends React.Component {
    render() {
        return (
            <td
                onDragOver={(e) => {
                    DragCell.reorder(this.props.dataItem);
                    e.preventDefault();
                    e.dataTransfer.dropEffect = "copy";
                }}
                onDragEnd={(e) => {
                    e.preventDefault();
                    DragCell.endDrag(this.props.dataItem);
                }}
            >
                <span
                    draggable="true"
                    style={{ cursor: "move" }}
                    onDragStart={(e) => {
                        DragCell.dragStart(this.props.dataItem);
                        e.dataTransfer.setData("dragging", "");
                    }}
                >
                    {this.props.dataItem.indexId}
                </span>
            </td>
        );
    }
}

class SelectAllCheckbox extends React.Component {
    render() {
        const { data, onClick } = this.props;
        const isNormalEntityPresent = data.some(item => !item.isUserEntity);
        const nonUserEntities = data.filter(item => !item.isUserEntity);
        const allMarkedToDelete = nonUserEntities.length ? nonUserEntities.every(item => item.toDelete) : false;

        return (
            <Checkbox
                disabled={!isNormalEntityPresent}
                className="k-checkbox-no-spacing"
                checked={allMarkedToDelete}
                onChange={onClick}
            />
        );
    }
}

function EntityNameCell(props) {

    const navigate = useNavigate();
    const { mutators } = useContext(WorkspaceAppModelContext);

    function navigateToEntityProperties() {
        if (mutators) {
            propogateChangeToRealtimeIframe(props.organizationId, props.projectId, "entitySelected", props.dataItem);
            propogateChangeToRealtimeIframe(props.organizationId, props.projectId, "entityEntered", { entity: props.dataItem });
            mutators.setSelectedEntity(props.dataItem);
        } else {
            navigate(`/${props.organizationName}/${props.projectName}/Entities/${props.dataItem.sysName}/Attributes`)
        }
    }

    return (
        <td className="link">
            <span className="text-link" onClick={navigateToEntityProperties}>
                {props.dataItem.name}
            </span>
        </td>
    )
}

class Entitiescomponents extends Component {

    static contextType = MsalContext

    createBtn = React.createRef();
    createAndNewBtn = React.createRef();

    options = ["Schema", "Organization", "Both"];

    constructor(props) {
        super(props);
        this.state = {
            redirect: false,
            panes: [
                { collapsible: false },
                { size: "475px", min: "475px", collapsible: false },
            ],
            data: [],
            toUpdateId: "",
            toDeleteIdL: "",
            ShowNotification: false,
            SideData: {},
            isNewbtn: false,
            IsNew: false,
            isInternalUser: false,
            showUpgradeDailog: false,
            loading: true,
            showServerError: false,
            showOnBoardingTooltip: false,
            processingEntity: false,
            referenceAttr: [],
            referenceBulkAttr: [],
            referenceChecked: false,
            recommendationDialogTitle: "Alice Recommendation - Objects",
            isAliceGPTDialogVisible: false,
            showBulkDeleteDialog: false,
            showAIChatbox: false
        };
        DragCell.reorder = this.reorder.bind(this);
        DragCell.dragStart = this.dragStart.bind(this);
        DragCell.endDrag = this.endDrag.bind(this);
        this.updateEntity = this.updateEntity.bind(this);
        this.EntitySidebar = React.createRef();
    }

    checkFormulaReference = async () => {
        this.setState({
            referenceAttr: [],
            referenceChecked: false,
            processingEntity: true
        });
        let properties = {};
        properties["entityId"] = this.state.SideData._id;
        properties["entityName"] = this.state.SideData.name;
        const checkFormulaResponse = await findEntityAttributeReferencesInFormulas(properties);
        this.setState({
            referenceAttr: Array.from(new Set(checkFormulaResponse.message)),
            referenceChecked: true,
            processingEntity: false
        });
    }

    checkBulkFormulaReference = async (selectedEntities) => {
        const referenceBulkAttr = [];

        const requests = selectedEntities.map(async (item) => {
            let properties = {
                entityId: item._id,
                entityName: item.name
            };
            return findEntityAttributeReferencesInFormulas(properties);
        });

        const responses = await Promise.all(requests);

        for (const response of responses) {
            const uniqueReferences = Array.from(new Set(response.message));
            referenceBulkAttr.push(...uniqueReferences);
        }

        this.setState({
            referenceBulkAttr: referenceBulkAttr
        });
    }


    rowRender = (trElement, props) => {
        const trProps = { className: "k-master-row" };
        if (props.dataItem.selected) {
            trProps.className += " k-state-selected";
        }
        if (props.dataItem.isHovered) {
            if (this.state.activeItemIndex > this.state.draggedOverItemIndex) {
                trProps.className = " hovered-row-above";
            } else {
                trProps.className = " hovered-row-below";
            }
        }
        return React.cloneElement(trElement, trProps, trElement.props.children);
    };

    componentDidMount = async () => {
        try {
            let result = await getEntities(this.props.project._id);
            const entities = result
                .slice()
                .sort((a, b) => a.order - b.order)
                .map((entity, index) => ({
                    ...entity,
                    indexId: index + 1,
                    numberOfAttributes: entity.numberOfAttributes - 5
                }));

            let ShowNotification = localStorage.getItem("ShowNotification");

            let isInternalUser = CheckForInternalUser(this.props.user.email)

            let selectedEntity = entities[0];
            if (this.props.sysName) {
                selectedEntity = entities.find(entity => entity.sysName === this.props.sysName);
            }
            if (selectedEntity === undefined) {
                selectedEntity = entities[0];
            }
            window.addEventListener("message", this.handleMessage);
            // remove it later
            // showRecommendEntityPopup: localStorage.getItem( "OpenRecommendedEntity" ),
            this.setState(
                {
                    IsNew: false,
                    toUpdateId: "",
                    isInternalUser: isInternalUser,
                    loading: false,
                    toDeleteId: "",
                    data: entities,
                    ShowNotification: ShowNotification,
                    showOnBoardingTooltip: this.props.user.applicationTooltipFlow === "true",
                },
                () => {
                    if (selectedEntity) {
                        this.rowClick(selectedEntity._id);
                    }
                }
            );
        } catch (error) {
            console.error(error)
            this.setState({
                showServerError: true
            })
        }
    };

    componentWillUnmount = () => {
        window.removeEventListener("message", this.handleMessage);
    }

    handleMessage = (event) => {
        if (event.origin === window.location.origin && typeof event.data === "string") {
            const data = JSON.parse(event.data);
            if (data.type === "GET_CONTEXT_REALTIME_API") {
                this.props.setInstanceId(data.instanceId);
                propogateChangeToRealtimeIframe(
                    this.props.organization._id,
                    data.instanceId,
                    "changeContext",
                    {
                        entityId: this.state.SideData?._id,
                    }
                )
            }
        }
    }

    handleEntityNameClick(entity) {
        if (this.props.isAccessedFromWorkspace) {
            this.props.selectEntity(entity);
        } else {
            this.navigateToEntity(entity);
        }
    }

    getInitialWidthForWindow = () => {
        // return 75% of the window width
        return window.innerWidth * 0.75;
    };

    getInitialHeightForWindow = () => {
        // return 80% of the window height
        return window.innerHeight * 0.8;
    };

    toggleAIChatbox = () => {
        this.setState({
            showAIChatbox: !this.state.showAIChatbox
        });
    }

    render() {
        if (this.state.showServerError) return <ServerError />
        if (this.state.redirect) {
            let url = `/${this.props.organization.orgName}/${this.props.project.name}/`;

            if (this.state.selected === 0) {
                url += "Entities";
            }

            if (this.state.selected === 1) {
                url += "Visualize";
            }

            this.setState({ redirect: false });

            return <Navigate to={url} />;
        }

        const { t } = this.props;

        return (
            <>
                {/* {
                    this.state.showOnBoardingTooltip &&
                    <OnBoardingTooltip
                        steps={applicationTooltipFlow}
                        onReset={this.toggleOnBoardingTooltip}
                    />
                } */}
                {this.state.DeletePopup && (
                    <RemoveDialog
                        toggleDeleteDialog={this.toggleDeleteDialog}
                        onDelete={this.DeleteConfirmation}
                        loading={this.state.processingEntity}
                        showLoader={this.state.processingEntity}
                        cancelButtonText={t("entity.delete_dialog.buttons.cancel_label")}
                        deleteButtonText={t("entity.delete_dialog.buttons.delete_label")}
                        message_old={`
                        Are you sure you want to delete <b class="txt-link">${this.state.data.find((entity) => entity._id === this.state.selectedId).name} </b>
                        ${ENTITY_LABEL.toLowerCase()}? Deleting this will remove all the items related to this object.
                        ${this.state.referenceAttr && this.state.referenceAttr.length > 0 ?
                                '<br/><p style="padding-top: 10px">We have detected this object is part of your configured calculated fields. Deleting it will remove any formula referenced by this object. To proceed, click the delete button.</p>'
                                : ''}
                        `}
                        message={
                            this.state.referenceAttr && this.state.referenceAttr.length > 0 ?
                                t("entity.delete_dialog.entity_with_reference_message", { entityName: this.state.data.find((entity) => entity._id === this.state.selectedId).name })
                                :
                                t("entity.delete_dialog.entity_without_reference_message", { entityName: this.state.data.find((entity) => entity._id === this.state.selectedId).name })
                        }
                        Title={t("entity.delete_dialog.title")}

                        referenceAttr={this.state.referenceAttr}
                        process={{
                            inProcess: !this.state.referenceChecked
                        }}
                        hideDeleteButton={this.state.referenceChecked && this.state.referenceAttr.length > 0}
                        hideCancelButton={this.state.referenceChecked && this.state.referenceAttr.length > 0}
                        orgName={this.props.organization.orgName}
                        projectName={this.props.project.name}
                        referenceMessage={`Please update the formula before you can remove this ${ENTITY_LABEL.toLowerCase()}.`}
                    />
                )}
                {this.state.isSaveEntityVisible && (
                    <SaveDialog
                        message={t("entity.unsaved_changes_dialog.message")}
                        Title={t("entity.unsaved_changes_dialog.title")}
                        SaveButtonText={t("entity.unsaved_changes_dialog.buttons.confirm_label")}
                        cancelButtonText={t("entity.unsaved_changes_dialog.buttons.cancel_label")}
                        onCancel={this.discardChanges}
                        toggleSaveDialog={this.toggleSaveEntityDialog}
                        onSave={this.SaveFromDialog}
                    />
                )}
                {
                    this.state.isAliceGPTDialogVisible &&
                    <AliceRecommendedEntitiesDialog
                        existingEntityNames={this.state.data.map(entity => entity.name)}
                        subscriptionId={this.props.organization.subscriptionId}
                        organization={this.props.organization}
                        project={this.props.project}
                        onEntitiesAdded={this.addCreatedEntitiesToGrid}
                        onLimitReached={this.toggleUpgradeDailog}
                        toggleDialog={this.toggleAliceGPTDialog} />
                }

                {this.state.showUpgradeDailog &&
                    <Upgarde
                        organization={this.props.organization}
                        Headline={'Need to build <br/>bigger apps? '}
                        toggleDialog={this.toggleUpgradeDailog}
                        Type={'Pro'}
                    />
                }

                <CreateEntityDialog
                    subscriptionId={this.props.organization.subscriptionId}
                    entities={this.state.data}
                    visible={this.state.isNewbtn}
                    toggle={this.toggleDialog}
                    onCreate={this.addEntityToGrid}
                    projectId={this.props.project._id}
                    createandNew={true}
                    toggleEntityImportDialog={this.showDefaultEntitiesPopup}
                />

                <PageContainer>
                    <div className="chngBtn1">
                        {this.props.project.developerMode ? (
                            <Header
                                header={t("entity.header.title")}
                                buttonLeft={true}
                                actionText={t("entity.header.buttons.create_label")}
                                actionTestId={"new-entity-btn"}
                                actionClicked={this.addNew}
                                actionDisabled={this.state.loading}
                                showAction={true}
                                action2Disabled={this.state.loading}
                                action2Text={this.props.showAIButtons && t("entity.header.buttons.ai_label")}
                                action2Icon={this.props.showAIButtons && "fas fa-lightbulb-on"}
                                action2Clicked={this.props.showAIButtons && this.toggleAliceGPTDialog}
                                showDeleteAction={this.state.data.find((item) => item.toDelete === true)}
                                deleteActionText={t("entity.header.buttons.delete_label")}
                                deleteActionClicked={this.toggleBulkDeleteDialog}
                                showHelpCenter={(this.state.isInternalUser && this.props.project.developerMode) ? true : false}
                                user={this.props.user}
                                helpCenterFor={t("entity.header.title")}
                            ></Header>
                        ) : (
                            <Header
                                header={t("entity.header.title")}
                                buttonLeft={true}
                                actionText={t("entity.header.buttons.create_label")}
                                actionTestId={"new-entity-btn"}
                                actionClicked={this.addNew}
                                actionDisabled={this.state.loading}
                                showAction={true}
                                action2Disabled={this.state.loading}
                                action2Text={this.props.showAIButtons && t("entity.header.buttons.ai_label")}
                                action2Icon={this.props.showAIButtons && "fas fa-lightbulb-on"}
                                action2Clicked={this.props.showAIButtons && this.toggleAliceGPTDialog}
                                showDeleteAction={this.state.data.find((item) => item.toDelete === true)}
                                deleteActionText={t("entity.header.buttons.delete_label")}
                                deleteActionClicked={this.toggleBulkDeleteDialog}
                                showHelpCenter={(this.state.isInternalUser && this.props.project.developerMode) ? true : false}
                                user={this.props.user}
                                helpCenterFor={t("entity.header.title")}
                            ></Header>
                        )}
                    </div>
                    <Content>
                        {
                            this.state.loading && <Loader />
                        }
                        {
                            this.state.loading === false &&
                            this.state.showAIChatbox &&
                            // <AIChatBox
                            //     context={`
                            //         You're in organization ${this.props.organization.orgName} and project ${this.props.project.name}.
                            //         Organization id is ${this.props.organization._id} and project id is ${this.props.project._id}.
                            //         Currently there are ${this.state.data.length} entities in this project.
                            //         The entities are ${this.state.data.map(entity => entity.name).join(", ")}.
                            //         The properties of each entity are:
                            //         ${this.state.data.map(entity => `
                            //             ${entity.name}: {
                            //                 name: ${entity.name},
                            //                 label: ${entity.label},
                            //                 pluralLabel: ${entity.pluralLabel},
                            //                 description: ${entity.description},
                            //                 icon: ${entity.icon},
                            //                 isUserEntity: ${entity.isUserEntity || false},
                            //                 numberOfAttributes: ${entity.numberOfAttributes},
                            //             }
                            //         `.trim()).join("\n -")}
                            //     `.trim()}
                            // />
                            <RealtimeAPIChatbox
                                organizationId={this.props.organization._id}
                                projectId={this.props.project._id}
                                subscriptionId={this.props.organization.subscriptionId}
                                entities={this.state.entities}
                            />
                        }
                        {
                            this.state.loading === false &&
                            this.state.showAIChatbox === false &&
                            this.state.data.length !== 0 && (
                                <Splitter
                                    panes={this.state.panes}
                                    onChange={this.onSplitterSizeChange}
                                >
                                    <div className="py-3 h-100 m-9">
                                        <Scrollable>
                                            {
                                                this.state.showBulkDeleteDialog &&
                                                <RemoveDialog
                                                    Title={t("entity.bulk_delete_dialog.title")}
                                                    loading={this.state.processingEntity}
                                                    showLoader={this.state.processingEntity}
                                                    toggleDeleteDialog={this.toggleBulkDeleteDialog}
                                                    message={
                                                        this.state.referenceBulkAttr && this.state.referenceBulkAttr.length > 0 ?
                                                            t("entity.bulk_delete_dialog.entity_with_reference_message", { entityCount: this.state.data.filter((item) => item.toDelete === true).length })
                                                            :
                                                            t("entity.bulk_delete_dialog.entity_without_reference_message", { entityCount: this.state.data.filter((item) => item.toDelete === true).length })
                                                    }
                                                    message_old={`
                                                    Are you sure you want to delete the
                                                    <b class="txt-link">${this.state.data.filter((item) => item.toDelete === true).length}</b>
                                                    objects? Deleting this will remove all the items related to those objects.
                                                    ${this.state.referenceBulkAttr && this.state.referenceBulkAttr.length > 0 ?
                                                            '<br/><p style="padding-top: 10px">We have detected some objects that are part of your configured calculated fields. Deleting these objects will remove any formula configurations referenced by these objects. To proceed, click the delete button.</p>'
                                                            : ''}
                                                    `}
                                                    onDelete={this.handleBulkDelete}
                                                    onCancel={this.toggleBulkDeleteDialog}
                                                    cancelButtonText={t("entity.bulk_delete_dialog.buttons.cancel_label")}
                                                    deleteButtonText={t("entity.bulk_delete_dialog.buttons.delete_label")}
                                                />
                                            }
                                            <Grid
                                                data={this.state.data.map((item, index) => ({
                                                    ...item,
                                                    selected: item._id === this.state.selectedId,
                                                    isHovered: index === this.state.draggedOverItemIndex,
                                                    index,
                                                }))}
                                                onRowClick={this.rowClick}
                                                selectedField="selected"
                                                reorderable={true}
                                            >
                                                <Column width={40}
                                                    cell={(props) => (
                                                        <td>
                                                            <Checkbox
                                                                disabled={props.dataItem.isUserEntity}
                                                                checked={props.dataItem.toDelete}
                                                                onChange={(e) => this.handleBulkDeleteSelection(e, props.dataItem)}
                                                            />
                                                        </td>
                                                    )}
                                                    headerCell={() => (
                                                        <SelectAllCheckbox
                                                            data={this.state.data}
                                                            onClick={this.handleSelectAllBulkDelete}
                                                        />
                                                    )}
                                                />
                                                <Column
                                                    field="indexId"
                                                    title={t("entity.table.columns.position")}
                                                    cell={DragCell}
                                                    width={40}
                                                />
                                                <Column
                                                    title={t("entity.table.columns.name")}
                                                    cell={(props) => (
                                                        <EntityNameCell
                                                            {...props}
                                                            organizationName={this.props.organization.orgName}
                                                            organizationId={this.props.organization._id}
                                                            projectId={this.props.project._id}
                                                            projectName={this.props.project.name} />
                                                    )}
                                                />
                                                <Column
                                                    title={t("entity.table.columns.label")}
                                                    cell={(o) => <td title={o.dataItem.label}>{o.dataItem.label}</td>}
                                                />
                                                <Column
                                                    field="numberOfAttributes"
                                                    title={t("entity.table.columns.num_properties")}
                                                />
                                            </Grid>
                                        </Scrollable>
                                    </div>
                                    <div className="h-100">
                                        {this.state.SideData._id && (
                                            <WorkspaceAppModelContext.Consumer>
                                                {
                                                    ({ state, mutators }) => (
                                                        <EntityPropertyPanel
                                                            subscription={this.props.subscription}
                                                            entityProperties={this.state.SideData}
                                                            EntityData={this.state.data}
                                                            Type="Attribute"
                                                            entityStateUpdater={this.updateEntity}
                                                            Delete={this.Delete}
                                                            project={this.props.project}
                                                            ref={this.EntitySidebar}
                                                            organizationId={this.props.organization._id}
                                                            organizationName={this.props.organization.orgName}
                                                            mutators={mutators}
                                                            isInternalUser={this.state.isInternalUser}
                                                        />
                                                    )
                                                }
                                            </WorkspaceAppModelContext.Consumer>
                                        )}
                                    </div>
                                </Splitter>
                            )}
                    </Content>
                </PageContainer>
            </>
        );
    }

    reorder(dataItem) {
        if (this.state.activeItem._id === dataItem._id) {
            if (
                this.state.draggedOverItemIndex !== this.state.activeItemIndex
            ) {
                this.setState({ draggedOverItemIndex: -1 });
            }
            return;
        }

        let draggedOverItemIndex = this.state.data.findIndex((p) => p._id === dataItem._id);

        this.setState({
            active: this.state.activeItem,
            draggedOverItemIndex,
        });
    }

    updateOrder = (_id, ordertoUpdate) => {
        updateEntity(_id, { order: ordertoUpdate })
    };

    endDrag(dataItem) {
        let { activeItemIndex, draggedOverItemIndex } = this.state;

        if (draggedOverItemIndex === -1) {
            return;
        }

        let reorderedData = this.state.data.slice();
        let temp = reorderedData[activeItemIndex];
        let index = draggedOverItemIndex;

        reorderedData.splice(activeItemIndex, 1);
        reorderedData.splice(draggedOverItemIndex, 0, temp);

        let newOrder;

        if (reorderedData.length > 2) {
            if (index === reorderedData.length - 1) {
                newOrder =
                    parseInt(reorderedData[index - 1]["order"]) + 10000000000;
                //console.log(index, newOrder);
                reorderedData[index]["order"] = newOrder;
                this.updateOrder(reorderedData[index]._id, newOrder);
            } else if (index === 0) {
                newOrder = parseInt(reorderedData[1]["order"]);
                let prevElementOrder = parseInt(reorderedData[2]["order"]);
                let orderToSet = (prevElementOrder + newOrder) / 2;
                reorderedData[index]["order"] = newOrder;
                reorderedData[1]["order"] = orderToSet;
                this.updateOrder(reorderedData[index]._id, newOrder);
                this.updateOrder(reorderedData[1]._id, orderToSet);
                //console.log(prevElementOrder, orderToSet, index);
            } else {
                let prevItemOrder = parseInt(reorderedData[index - 1]["order"]);
                let nextItemOrder = parseInt(reorderedData[index + 1]["order"]);
                newOrder = (prevItemOrder + nextItemOrder) / 2;
                reorderedData[index]["order"] = newOrder;
                this.updateOrder(reorderedData[index]._id, newOrder);
            }
        } else {
            let firstOrder = reorderedData[0]["order"];
            let secondOrder = reorderedData[1]["order"];

            reorderedData[0]["order"] = secondOrder;
            reorderedData[1]["order"] = firstOrder;

            this.updateOrder(reorderedData[0]._id, secondOrder);
            this.updateOrder(reorderedData[1]._id, firstOrder);
        }

        for (let i = 0; i < reorderedData.length; i++) {
            reorderedData[i].indexId = i + 1;
        }

        this.setState({
            data: reorderedData,
            selectedId: this.state.oldSelectedId,
            activeItemIndex: -1,
            draggedOverItemIndex: -1,
        });
    }

    dragStart(dataItem) {
        var oldSelectedId = this.state.selectedId;
        let activeItemIndex = this.state.data.findIndex(
            (entity) => entity._id === dataItem._id
        );
        this.setState({
            data: this.state.data,
            activeItem: dataItem,
            activeItemIndex: activeItemIndex,
            oldSelectedId: oldSelectedId,
            selectedId: dataItem._id,
        });
    }

    rowClick = (value) => {
        if (
            value && value.nativeEvent && value.nativeEvent.detail === 2
        ) {
            if (this.props.isAccessedFromWorkspace && this.props.selectEntity) {
                this.props.selectEntity(value.dataItem)
            } else {
                this.navigateToEntity(value.dataItem)
            }
        }
        if (
            this.EntitySidebar.current !== null &&
            this.EntitySidebar.current.getDisabled() === false
        ) {
            const isEntityDeleted = this.state.data.find(x => x._id === this.EntitySidebar.current.defaultData._id) === undefined;
            if (!isEntityDeleted) {
                let s = this.EntitySidebar.current.getDisabled();
                this.toggleSaveEntityDialog();
                this.setState({
                    nextEntity:
                        value.dataItem !== undefined ? value.dataItem._id : value,
                });
                return;
            }
        }

        this.setState({
            SideData: {},
        });

        var id = "";

        if (value["dataItem"]) {
            id = value.dataItem._id;
        } else {
            id = value;
        }
        this.setState({ selectedId: id });
        let element = this.state.data.find((x) => x._id === id);

        this.setState({ SideData: element });

        propogateChangeToRealtimeIframe(this.props.organization._id, this.props.instanceId, "entitySelected", element);
    };

    navigateToEntity = (dataItem) => {
        const { project, organization } = this.props;
        const { orgName } = organization
        const { name } = project
        this.props.navigate(
            `/${orgName}/${name}/Entities/${dataItem.sysName}/Attributes`
        );
    }

    onSplitterSizeChange = (e) => {
        this.setState({ panes: e.newState });
    };

    addNew = () => {
        this.setState({
            isNewbtn: true,
            label: "",
        });
    };

    toggleOnBoardingTooltip = () => {
        updateNode("User", this.props.user._id, {
            applicationTooltipFlow: "false"
        })
        this.setState({
            showOnBoardingTooltip: false
        })
        this.props.updateUser({
            applicationTooltipFlow: "false"
        })
    }

    toggleDialog = (showUpgradeDailog) => {
        this.setState({
            isNewbtn: false,
            showUpgradeDailog: showUpgradeDailog,
            entityName: "",
            label: "",
            pluralLabel: "",
            description: "",
            colorHex: "",
            toUpdateId: "",
            color: "#000",
            value: "",
            showError: false,
            showInherit: false,
        });
    };

    toggleUpgradeDailog = () => {
        this.setState({
            showUpgradeDailog: !this.state.showUpgradeDailog
        })
    }

    toggleDeleteDialog = (e) => {
        this.setState({
            DeletePopup: false,
            entityName: "",
            label: "",
            pluralLabel: "",
            description: "",
            colorHex: "",
            toUpdateId: "",
            color: {
                r: "0",
                g: "0",
                b: "0",
                a: "1",
            },
            value: "",
        });
    };

    toggleSaveEntityDialog = () => {
        this.setState({ isSaveEntityVisible: !this.state.isSaveEntityVisible });
    };

    handleSelectAllBulkDelete = (e) => {
        let { data } = this.state
        data.forEach((item) => {
            if (!item.isUserEntity) {
                item.toDelete = e.value
            }
        })
        this.setState({ data })
    }

    handleBulkDeleteSelection = (e, dataItem) => {
        let { data } = this.state
        let selectedData = data.find((item) => item._id === dataItem._id)
        selectedData.toDelete = dataItem.isUserEntity ? false : e.value
        this.rowClick(dataItem._id)
        this.setState({ data })
    }

    handleBulkDelete = async () => {
        let { data } = this.state;
        let selectedEntityIds = data.filter((item) => item.toDelete === true).map((item) => item._id);

        if (selectedEntityIds.length > 0) {
            this.setState({
                processingEntity: true
            })

            const bulkDeleteResponse = await bulkDeleteEnities(this.props.project._id, selectedEntityIds);

            if (bulkDeleteResponse.status === "Success") {
                this.deleteFormula();
                const remaingEntities = data.filter((item) => item.toDelete === false || item.toDelete === undefined);

                for (let i = 0; i < remaingEntities.length; i++) {
                    remaingEntities[i].indexId = i + 1;
                }

                if (remaingEntities.length === 0) {
                    this.setState({
                        processingEntity: false,
                        data: remaingEntities,
                        showBulkDeleteDialog: false
                    });
                } else {
                    this.setState({
                        data: remaingEntities,
                        processingEntity: false,
                        showBulkDeleteDialog: false
                    }, () => {
                        const entityToSelectId = remaingEntities.length > 1 ? remaingEntities[1]._id : remaingEntities[0]._id;
                        this.rowClick(entityToSelectId);
                    })
                }
            } else {
                this.setState({
                    processingEntity: false,
                    showBulkDeleteDialog: false
                })
            }
        }
    }

    // delete formula
    deleteFormula = async () => {
        var referenceAttr = this.state.referenceAttr.length > 0 ? this.state.referenceAttr : this.state.referenceBulkAttr;
        for (let item of referenceAttr) {
            const entity = this.state.data.find(entityItem => entityItem._id === item.entityId);
            if (entity) {
                const allEntityAttributes = await getAllAttributes(entity._id);
                const linkedAttributes = allEntityAttributes.find(attrItem => attrItem._id === item.attributeId);
                linkedAttributes.formula = '';
                linkedAttributes.formulaJson = '';
                const triggerSettingObj = JSON.parse(linkedAttributes.triggerSetting);
                triggerSettingObj.formulaEnabled = false;
                const updatedTriggerSettingStr = JSON.stringify(triggerSettingObj);
                linkedAttributes.triggerSetting = updatedTriggerSettingStr;
                linkedAttributes.readOnly = false;
                await updateAttribute(linkedAttributes._id, linkedAttributes);
            }
        }
    }


    toggleBulkDeleteDialog = async () => {
        this.setState(
            (prevState) => ({
                showBulkDeleteDialog: !prevState.showBulkDeleteDialog,
                processingEntity: true


            }),

        );
        let { data } = this.state;
        console.log("data", data);
        console.log(this.state)
        let selectedEntities = data
            .filter((item) => item.toDelete === true)
            .map((item) => ({ _id: item._id, name: item.name }));

        await this.checkBulkFormulaReference(selectedEntities);
        this.setState({
            processingEntity: false
        });
    }

    SaveFromDialog = (e) => {
        this.EntitySidebar.current.update(e, () => {
            this.EntitySidebar.current.setDisabled();
            this.toggleSaveEntityDialog();
            this.rowClick(this.state.nextEntity);
        });
    };

    discardChanges = async (e) => {
        // await this.EntitySidebar.current.setDefault();
        this.toggleSaveEntityDialog();
        // this.rowClick(this.state.nextEntity);
    };

    addEntityToGridViaRecommendation = (response) => {
        if (response.message === "Max entities allowed limit reached") {
            this.toggleDialog(true);
        } else {
            const data = response.map(entity => ({
                ...entity,
                numberOfAttributes: entity.numberOfAttributes.low
            }))
            const newData = [...this.state.data, ...data].map((entity, index) => ({
                ...entity,
                _id: index + 1
            }));
            this.setState({
                data: newData
            });
        }
    }

    addEntityToGrid = (entity, isCreateandNew) => {
        if (isCreateandNew === false) {
            const { data } = this.state;
            entity.numberOfAttributes = entity.numberOfAttributes || 0;
            entity.index = data.length + 1;
            const newData = [...data, entity];
            this.setState({
                selectedId: entity._id,
                SideData: entity,
                data: newData,
            })
            this.toggleDialog()
        } else {
            const { data } = this.state;
            entity.numberOfAttributes = entity.numberOfAttributes || 0;
            entity.index = data.length + 1;
            const newData = [...data, entity];
            this.setState({
                data: newData,
            }, () => {
                this.rowClick(entity._id)
            })
        }
    }

    updateEntity(_id, entityData) {
        let data = this.state.data;
        let index = data.findIndex((x) => x._id === _id);

        if (index !== -1) {
            let indexId = data[index].indexId;
            let numberOfAttributes = data[index].numberOfAttributes;

            // Update entity data while preserving _id and numberOfAttributes
            data[index] = {
                ...entityData,
                indexId: indexId,
                numberOfAttributes: numberOfAttributes,
            };

            this.setState({ data: data, SideData: entityData });
        } else {
            console.error(`Entity with _id ${_id} not found.`);
        }
    }

    Delete = (e) => {
        const id = e.currentTarget === undefined ? e : e.currentTarget.value;
        let element = this.state.data.find((x) => x._id === id);
        this.setState({
            DeletePopup: true,
            toDeleteId: element._id,
        });
        var res = this.checkFormulaReference(element._id);
    };

    DeleteConfirmation = async (e) => {
        this.deleteFormula();
        this.setState({ processingEntity: true })
        e.target.disabled = true;
        let element = this.state.data.find((x) => x._id === this.state.toDeleteId);
        await this.remove(element);
        this.setState({
            DeletePopup: !this.state.DeletePopup,
            toDeleteId: "",
            processingEntity: false
        });
    };

    remove = async (dataItem) => {
        await deleteEntity(this.props.project._id, dataItem._id);
        const data = [...this.state.data];
        let index = data.findIndex((p) => p === dataItem || (dataItem._id && p._id === dataItem._id));
        let toGet = 0;
        if (index >= 0) {
            data.splice(index, 1);
        }

        for (let i = 0; i < data.length; i++) {
            data[i].indexId = i + 1;
        }

        let child = data.filter((x) => x.inherits === dataItem.name);
        child.forEach((x) => (x.inherits = "false"));

        this.setState({ data: data }, () => {
            if (index === 0) {
                if (data.length > 0) {
                    this.rowClick(data[toGet]._id);
                } else {
                    this.setState({
                        SideData: {}
                    });
                }
            } else {
                toGet = index - 1;
                if (this.state.selectedId === dataItem._id) {
                    this.rowClick(data[toGet]._id);
                }
            }
        });
    };

    toggleAliceGPTDialog = () => {
        this.setState({ isAliceGPTDialogVisible: !this.state.isAliceGPTDialogVisible });
    }

    addCreatedEntitiesToGrid = (entities) => {
        const { data } = this.state;
        const newData = [...data, ...entities].map((entity, index) => ({
            ...entity,
            indexId: index + 1
        }));
        this.setState({
            data: newData
        }, () => {
            this.rowClick(entities[0]._id)
        });
    }
}

export default withTranslation()(Entitiescomponents);
